import type { IMesh } from '@seddi/mesh';
import type { FxMesh, VertexDataDesc } from '@seddi/ui-babylon-core';

/**
 * Converts a mesh resource to a viewport mesh descriptor.
 * @param mesh - Mesh resource to adapt.
 */
function adapt(mesh: IMesh): FxMesh {
  const { id, geometry } = mesh;
  const vgeometry: VertexDataDesc = {
    indices: geometry.indices,
    positions: geometry.position!,
    normals: geometry.normal,
    uvs: geometry.uv_0,
  };
  const vmesh: FxMesh = { id, geometry: vgeometry };
  return vmesh;
}

/**
 * Class for adapting a button to a mesh geometry with surface material.
 */
export const MeshAdapter = {
  adapt,
};
